module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/Instagram.855ad0ef.svg";